const getContactInfo = () => ({
    email1: 'info@kapp.rw',
    email2: 'info@oto.rw',
});

export default getContactInfo;
